import RouterUtils from '../../../../../shared/routing/RouterUtils';
import { ApiEndpoints } from '../../../../../shared/webservices/endpoint';
import WorkerState from '../../../../../shared/model/WorkerState';

export class WorkerUpdateRequest {

    // WorkerContractorSave {
    //   id: number
    //   contractor_id: number
    //   document_schema_id: number
    // }

    _id; // number
    _dni; // string
    _name; // string
    _position; // string
    _lastName; // string
    _agreement; // string
    _contractors; // WorkerContractorSave[]
    _workerStateId; // number

    constructor(values, worker) {
        this._id = worker.id();
        this._dni = values.dni;
        this._name = values.name;
        this._position = values.job;
        this._lastName = values.lastName;
        this._agreement = values.agreement;
        this._companyId = worker.companyId();
        this._contractors = this._parseContractorSchemas(values, worker);
        this._workerStateId = values.state ? WorkerState.ACTIVE : WorkerState.INACTIVE;
    }

    url() {
        return RouterUtils.generateRoute(ApiEndpoints.WORKER_ID, { id: this._id });
    }

    body() {
        return {
            id: this._id,
            dni: this._dni,
            name: this._name,
            position: this._position,
            last_name: this._lastName,
            agreement: this._agreement,
            company_id: this._companyId,
            contractors: this._contractors,
            worker_state_id: this._workerStateId,
        };
    }

    _parseContractorSchemas(values, worker) {
        const nextSchemas = {};

        worker
            .documentation()
            .schemas()
            .forEach((s) => {
                nextSchemas[s.contractorId()] = {
                    contractor_id: s.contractorId(),
                    document_schema_id: s.documentSchemaId(),
                    position: s.position,
                };
            });

        values
            .contractorSchemas
            .forEach((s) => {
                if ( nextSchemas[s.contractorId] ) {
                    if ( s.schema.length !== 0 ) {
                        nextSchemas[s.contractorId].document_schema_id = s.schema[0].value;
                        nextSchemas[s.contractorId].position = s.position;
                    } else {
                        nextSchemas[s.contractorId] = null;
                    }
                } else {
                    if ( s.schema.length !== 0 ) {
                        nextSchemas[s.contractorId] = {
                            contractor_id: s.contractorId,
                            document_schema_id: s.schema[0].value,
                            position: s.position,
                        };
                    }
                }
            });

        return Object
            .values(nextSchemas)
            .filter(nextSchema => nextSchema !== null)
            .map((nextSchema) => ( {
                contractor_id: nextSchema.contractor_id,
                document_schema_id: nextSchema.document_schema_id !== -1
                    ? nextSchema.document_schema_id
                    : null,
                position: nextSchema.position,
            } ));
    }
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/worker/form/update/worker-update/WorkerUpdateRequest.js